var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:_vm.setClassProduct},[(_vm.fotos && _vm.fotos.length > 0)?_c('SpecificItemPage',{attrs:{"main-img":_vm.fotos[0].foto,"img-name":_vm.product.nombre},scopedSlots:_vm._u([{key:"grid-content",fn:function(){return [_c('DinamicGridImages',{attrs:{"fotos":_vm.getObrasByProduct}})]},proxy:true}],null,false,3920014267)}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }